import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const LeaveApplicationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    uid: "",
    leaveType: "",
    fromDate: "",
    toDate: "",
    reason: "",
    // phone: ""
  });
  const [doctors, setDoctors] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDoctors = async () => {
        const headerList = {
            "Accept": "*/*",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('token')}`
          };
      try {
        const response = await axios.post("https://www.careplus.gopillz.com/send_leave_doctor",
        {},
        { headers: headerList }
        ); // Replace with your actual endpoint
        setDoctors(response.data.data); // Expected format: [{id, name, phone}]
        setFormData(prev => ({
          ...prev,
          uid: response.data.data[0].uid,
          name:response.data.data[0].patiner_name
        }));
      } catch (err) {
        console.error("Error fetching doctors:", err);
      }
    };

    fetchDoctors();
  }, []);

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData, "-0-0-0-0-0")
  
    // Basic validation
    for (const key in formData) {
      if (!formData[key].trim()) {
        setError("Please fill all fields before submitting.");
        return;
      }
    }
  
    try {
      const response = await fetch("https://www.careplus.gopillz.com/send_leave_alert", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`

        },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        setError(data.message || "Something went wrong. Please try again.");
        return;
      }
  
      setError("");
      alert("Leave application submitted successfully!");
      navigate("/ask")
      // Optionally, reset form:
      // setFormData({ name: "", uid: "", ... })
    } catch (err) {
      setError("Network error. Please try again later.");
    }
  };
  

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-teal-200">
      <Navbar />
      <div className="max-w-3xl mx-auto mt-12 bg-white rounded-3xl shadow-2xl p-10 backdrop-blur-md">
        <h2 className="text-3xl font-bold text-center text-teal-700 mb-8">Leave Application Form</h2>

        {error && <p className="text-red-500 font-medium text-center mb-4">{error}</p>}

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-6">
          <div>
            <label className="block text-gray-700 font-semibold mb-1">Full Name</label>
            <input
              name="name"
              type="text"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-teal-400 shadow-inner"
              placeholder="Enter your full name"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1">UID / Roll Number</label>
            <input
              name="uid"
              type="text"
              value={formData.uid}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-teal-400 shadow-inner"
              placeholder="Enter UID or Roll No."
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-1">Leave Type</label>
            <select
              name="leaveType"
              value={formData.leaveType}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-teal-400 shadow-inner"
            >
              <option value="">Select Leave Type</option>
              <option value="Sick">Sick Leave</option>
              <option value="Casual">Casual Leave</option>
              <option value="Emergency">Emergency Leave</option>
              <option value="Others">Others</option>
            </select>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-700 font-semibold mb-1">From Date</label>
              <input
                name="fromDate"
                type="date"
                value={formData.fromDate}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-teal-400 shadow-inner"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-1">To Date</label>
              <input
                name="toDate"
                type="date"
                value={formData.toDate}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-teal-400 shadow-inner"
              />
            </div>
          </div>

          {/* <div>
            <label className="block text-gray-700 font-semibold mb-1">Phone Number</label>
            <input
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-teal-400 shadow-inner"
              placeholder="Enter your phone number"
            />
          </div> */}

          <div>
            <label className="block text-gray-700 font-semibold mb-1">Reason</label>
            <textarea
              name="reason"
              rows="4"
              value={formData.reason}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-teal-400 shadow-inner"
              placeholder="State your reason for leave"
            />
          </div>
          <div>
            <label className="block text-gray-700 font-semibold mb-1">Send Alert to Doctor</label>
            <select
              name="doctor"
              value={formData.doctor}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-teal-400 shadow-inner"
            >
              <option value="">Select Doctor</option>
              {doctors.map((doc) => (
                <option key={doc.id} value={`${doc.name} (${doc.phone})`}>
                  {doc.name} - {doc.phone}
                </option>
              ))}
            </select>
          </div>

          <div className="flex justify-center mt-6">
            <button
              type="submit"
              className="bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white font-semibold py-3 px-10 rounded-full shadow-md hover:scale-105 transition-transform"
            >
              Submit Application
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LeaveApplicationForm;
